import { getCdnLink } from 'tools/getCdnLink';

export const specialChartScripts = [
    // For use with colorAxis it is required to also include the modules for heatmaps.
    { treemap: [getCdnLink('js/highcharts/heatmap-7.2.1.js'), getCdnLink('js/highcharts/treemap-7.2.1.js')] },
    { map: [getCdnLink('js/highcharts/map-7.2.1.js'), getCdnLink('js/highcharts/world-7.2.1.js')] },
    { drillDownTreeMap: [getCdnLink('js/highcharts/heatmap-7.2.1.js'), getCdnLink('js/highcharts/treemap-7.2.1.js')] },
    { heatmap: getCdnLink('js/highcharts/heatmap-7.2.1.js') },
    { waterFall: getCdnLink('js/highcharts/highcharts-7.2.2/highcharts-more.js') },
    { spiderWeb: getCdnLink('js/highcharts/highcharts-7.2.2/highcharts-more.js') },
];

export const essentialChartScripts = [
    getCdnLink('js/highcharts/highcharts-7.2.2/highcharts.js'),
    getCdnLink('js/highcharts/highcharts-7.2.2/highcharts-more.js'),
    getCdnLink('js/highcharts/highcharts-7.2.2/exporting.js'),
    getCdnLink('js/highcharts/highcharts-7.2.2/data.js'),
];
